<script setup>
const route = useRoute()
const years = ['2018', '2019', '2020', '2021', '2022', '2023', '2024']

const highyear = computed(() => {
  // console.log('route.params.year', route.params.year)
  return route.params.year === '2019'// value.some(({name}) => /^(shows)$/);
})
</script>

<template>
  <div>
    <div class="justify-between items-center pt-3 pl-4 sm:pl-10">
      <div class="flex flex-wrap">
        <NuxtLink
          v-for="year in years" :key="year" :to="`/shows/${year}`"
          :class="{ highyear: year === route.params.year }"
          class="uppercase sg-bold bg-green-500 px-2 skew-x-20 mr-2 mb-2"
        >
          <div class="skew-x-160 text-white">
            {{ year }}
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style scoped>
.router-link-exact-active,
.highyear {
  background-color: dodgerblue;
}

.router-link-active {
  background-color: dodgerblue;
}
</style>
